export const groupDefaultOption = { value: 'all', label: 'All' };

export const getGroupsOptions = (groups: Record<string, any> = [], category) => {
  const availableGroups = groups.filter(
    group => group?.categories?.length === 0 || group?.categories?.some(ctg => ctg.code === category?.code)
  );

  return [groupDefaultOption, ...availableGroups.map(item => ({ value: item.id, label: item.name, group: item }))];
};
